// Each value set is declared once; db column enums and contracts zod enums derive from these.
export const SPORTS = ['ride', 'run', 'swim', 'walk', 'strength', 'other'] as const;
export const SOURCES = ['fit', 'strava'] as const;
export const ACTIVITY_STATUSES = ['pending', 'processed', 'failed'] as const;
// 'sport-unsupported' is never written any more; rows stored before every sport had Load keep it until reprocessed.
export const NO_LOAD_REASONS = ['no-power', 'no-ftp', 'no-hr', 'no-threshold', 'sport-unsupported'] as const;
export const LOAD_METHODS = ['power', 'pace', 'hr'] as const;
// Thresholds are kept per threshold sport: swim, walk, strength and other share 'other'.
export const THRESHOLD_SPORTS = ['ride', 'run', 'other'] as const;
export const THRESHOLD_KINDS = ['ftp', 'lthr', 'max_hr', 'threshold_pace'] as const;
export const THRESHOLD_SOURCES = ['manual', 'strava', 'ride', 'suggested'] as const;
export const HR_ZONE_MODELS = ['lthr', 'max_hr'] as const;
export const FORM_ZONES = ['fresh', 'neutral', 'productive', 'overreaching'] as const;

export type Sport = (typeof SPORTS)[number];
export type Source = (typeof SOURCES)[number];
export type ActivityStatus = (typeof ACTIVITY_STATUSES)[number];
export type NoLoadReason = (typeof NO_LOAD_REASONS)[number];
export type ThresholdKind = (typeof THRESHOLD_KINDS)[number];
export type ThresholdSource = (typeof THRESHOLD_SOURCES)[number];
export type HrZoneModel = (typeof HR_ZONE_MODELS)[number];
export type FormZone = (typeof FORM_ZONES)[number];
export type LoadMethod = (typeof LOAD_METHODS)[number];
export type ThresholdSport = (typeof THRESHOLD_SPORTS)[number];

// Planned block types, in Zwift's zone order (Rest first, Race last).
export const PLAN_TYPES = ['rest', 'recovery', 'endurance', 'tempo', 'sweet-spot', 'threshold', 'vo2-max', 'race'] as const;
export type PlanType = (typeof PLAN_TYPES)[number];
